// extracted by mini-css-extract-plugin
export default {"main":"bc436506f6 _326c66edfd","xmark":"_767cb3f9bd","fl_img":"dc46b15da2 _34e15c6285"};